// extracted by mini-css-extract-plugin
module.exports = {"messageModalContainer":"styles_messageModalContainer__3o2OB","title":"styles_title__3pZcQ","text":"styles_text__6bOBb","actionsButtons":"styles_actionsButtons__waRp6"};